import { IContractNodeStyleConfing } from "../../models/graph-kn.cm.nodes-model-const"
import { baseLight, basePrimary,textPrimary } from "../graph-colors"
export const Contract_Node_Style_Config:IContractNodeStyleConfing = {
	icon:{
		iconBackGround:baseLight,
		iconBackGroundHeight:40,
		iconRadius:0,
		iconHeight:40,
	},
	iconGap: 10,
	textMain:{
		offsetX:0,
		fontFamily:'Onest',
		fontSize:16,
		fill:textPrimary,
		verticalAlign:'middle',
		align:'left'
	},
	textCounter: {
		fontFamily:'Onest',
		fontSize:24,
		fontStyle:'bold',
		fill:basePrimary,
		verticalAlign:'middle',
		offsetX: -10,
		offsetY:-5,
		maxWidth:0.3
	},
	counterGap:14
}
export const Contract_Steps_Icons: Map<string,{stepIcon:string}>  = new Map ([
	['task',  {stepIcon:'../../../../assets/icons/presentation-fill.svg'}],
	['file',  {stepIcon:'../../../../assets/icons/file-text-fill.svg'}],
	['credit_letter',  {stepIcon:'../../../../assets/icons/bank-fill.svg'}],
	['general_credit_letter',  {stepIcon:'../../../../assets/icons/bank-fill.svg'}],
	['direct_payment',  {stepIcon:'../../../../assets/icons/wallet-2-fill.svg'}],
	['payment',  {stepIcon:'../../../../assets/icons/bank-fill.svg'}],
	['sub_contract',  {stepIcon:'../../../../assets/icons/file-copy-2-fill.svg'}],
	['multi_payment',  {stepIcon:'../../../../assets/icons/coins-fill.svg'}]
])

export type TStepTypeCode =
    'file'
    | 'task'
    | 'sub_contract'
    | 'credit_letter'
    | 'payment'
    | 'direct_payment'
    | 'multi_payment'
    | 'general_credit_letter'
export const KN_STEPS_STYLES_MAP: Map<TStepTypeCode, {
    icon: string,
    color: string,
    title: string,
    headerColor: string,
    selected: boolean
}> = new Map([
    ['file', {
        icon: '../../../../assets/images/contract/step-icons/file-text-fill-40-b.svg',
        color: '#9FA8DA',
        headerColor: '#7085B2',
        title: 'CONTRACTS.TEXT.STEPS.DOCUMENT',
        selected: false
    }],
    ['task', {
        icon: '../../../../assets/images/contract/step-icons/task-fill-40-y.svg',
        color: '#FFCC80',
        headerColor: '#9F803B',
        title: 'CONTRACTS.TEXT.STEPS.TASK',
        selected: false
    }],
    ['sub_contract', {
        icon: '../../../../assets/images/contract/step-icons/file-upload-fill-40-g.svg',
        color: '#ffffff',
        headerColor: '#7085B2',
        title: 'CONTRACTS.TEXT.STEPS.SUBCONTRACT',
        selected: false
    }],
    ['payment', {
        icon: '../../../../assets/images/contract/step-icons/wallet-2-40-g.svg',
        color: '#66BB6A',
        headerColor: '#4F8C66',
        title: 'CONTRACTS.TEXT.STEPS.CREDIT_LETTER',
        selected: false
    }],
    ['multi_payment', {
        icon: '../../../../assets/images/contract/step-icons/coins-fill-40-g.svg',
        color: '#C5E1A5',
        headerColor: '#4F8C66',
        title: 'CONTRACTS.TEXT.STEPS.MULTIPAYMENT',
        selected: false
    }],
    ['direct_payment', {
        icon: '../../../../assets/images/contract/step-icons/wallet-2-40-g.svg',
        color: '#66BB6A',
        headerColor: '#4F8C66',
        title: 'CONTRACTS.TEXT.STEPS.PAYMENT',
        selected: false
    }],
    ['credit_letter', {
         icon: '../../../../assets/images/contract/step-icons/bank-fill-40-g.svg',
        color: '#C8E6C9',
        headerColor: '#4F8C66',
        title: 'CONTRACTS.TEXT.STEPS.COLLATERAL',
        selected: false
    }],
    ['general_credit_letter', {
        icon: '../../../../assets/images/contract/step-icons/bank-fill-40-g.svg',
        color: '#C8E6C9',
        headerColor: '#4F8C66',
        title: 'CONTRACTS.TEXT.STEPS.COLLATERAL',
        selected: false
    }],
]) 
